module.exports = __webpack_public_path__ + "static/logo_jkl-088db91e67d9d827a0479d399269efad.png";